import { client } from "@/api/client";
import { validateResponse } from "@/api/utils";
import {
  userInfoSchema,
  type LoginParams,
  type LoginResponse,
  type UserInfo,
} from "@/pages/login/type/loginType";

export const loginApi = {
  login: async (params: LoginParams): Promise<LoginResponse> => {
    const response = await client.post("/login", params);
    return response.data;
  },
  info: async (): Promise<UserInfo> => {
    const response = await client.get("/account/my-info");
    // 권한 분기의 근거가 되므로 role/affiliation.type 계약을 엄격 검증한다.
    return validateResponse(
      userInfoSchema,
      response.data.data,
      "GET",
      "/account/my-info",
    );
  },
};
